import { useState } from 'react';

import type { ReactNode } from 'react';

import loadable from '@loadable/component';

import { useFlag } from '@/features/unleash';

import type { Brokerage } from '../../hooks/useBrokerages';

const LinkingInstructionsModal = loadable(
  () => import('./LinkingInstructionsModal'),
  {
    resolveComponent: (component) => component.LinkingInstructionsModal,
  }
);

interface Props {
  brokerage: Brokerage;
  children: ReactNode;
  onClose: () => void;
}

const brokerList = ['9223b7dd-7e73-4a1f-85ad-84b7d5fe4ca9'];

export const LinkingWithInstructions = ({
  brokerage,
  children,
  onClose,
}: Props) => {
  const featureFlag = useFlag({ name: 'mono-portfolio-linking-instructions' });

  const canAccessLinkingInstructions =
    featureFlag.enabled && featureFlag.flagsReady;

  const [seenInstructions, setSeen] = useState(false);

  if (
    canAccessLinkingInstructions &&
    brokerList.includes(brokerage.id) &&
    seenInstructions === false
  ) {
    return (
      <LinkingInstructionsModal
        onClose={onClose}
        onConfirm={() => setSeen(true)}
      />
    );
  }

  return children;
};
